/** 项目已关联 gateway（含 Agent 尚未上线），用于绑定/解绑入口 */
export function isHostLinked(project: {
  gatewayId?: string | null;
  agentKeyStatus?: string;
  deliveryStatus?: string;
}): boolean {
  const g = project.gatewayId;
  if (!g || g === "—" || !String(g).trim()) return false;
  if (project.agentKeyStatus === "revoked") return false;
  const delivery = project.deliveryStatus || "";
  if (delivery === "待认领" || delivery === "pending_claim") return false;
  return true;
}

/** 客户是否已绑定可远程接入的主机（gateway 且 Agent 在线） */
export function isHostBound(project: {
  gatewayId?: string | null;
  agentStatus?: string;
  deliveryStatus?: string;
}): boolean {
  const g = project.gatewayId;
  const hasGwId = Boolean(g && g !== "—" && String(g).trim() !== "");
  if (!hasGwId) return false;

  const delivery = project.deliveryStatus || "";
  if (delivery === "待认领" || delivery === "pending_claim") return false;

  const agent = (project.agentStatus || "").trim();
  if (
    !agent ||
    agent === "未绑定主机" ||
    agent === "未激活" ||
    agent === "已断开"
  ) {
    return false;
  }

  return agent === "已连接" || agent === "在线" || agent === "告警";
}

/** 待认领 / 可绑定主机（含残留 gateway_id 但未真正连上的记录） */
export function isPendingClaim(project: {
  deliveryStatus?: string;
  gatewayId?: string | null;
  agentStatus?: string;
}): boolean {
  if (isHostBound(project)) return false;
  const st = project.deliveryStatus || "";
  if (st === "待认领" || st === "pending_claim") return true;
  if (st === "调试中" || st === "debugging") {
    const agent = (project.agentStatus || "").trim();
    return (
      !agent ||
      agent === "未绑定主机" ||
      agent === "未激活" ||
      agent === "已断开"
    );
  }
  return false;
}
